import type { NextResponse } from 'next/server'
import { STYTCH_MAX_SESSION_DURATION_MINUTES } from '@/utilities/stytch/config'

export const CLIENT_HAD_SESSION_COOKIE = 'ash_client_had_session'

// One day past the longest Stytch session.
// The marker remains after stytch_session_jwt ends.
const CLIENT_HAD_SESSION_EXTRA_MINUTES = 24 * 60
export const CLIENT_HAD_SESSION_MAX_AGE_SECONDS =
  (STYTCH_MAX_SESSION_DURATION_MINUTES + CLIENT_HAD_SESSION_EXTRA_MINUTES) * 60

function buildBaseAttributes(): string {
  const attributes: string[] = ['Path=/', 'SameSite=Lax']
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:') {
    attributes.push('Secure')
  }
  return attributes.join('; ')
}

export function setClientHadSessionCookie(): void {
  if (typeof document === 'undefined') return
  const base = buildBaseAttributes()
  document.cookie = `${CLIENT_HAD_SESSION_COOKIE}=1; Max-Age=${CLIENT_HAD_SESSION_MAX_AGE_SECONDS}; ${base}`
}

export function clearClientHadSessionCookie(): void {
  if (typeof document === 'undefined') return
  const base = buildBaseAttributes()
  document.cookie = `${CLIENT_HAD_SESSION_COOKIE}=; Max-Age=0; ${base}`
}

export function expireClientHadSessionCookie(response: NextResponse, secure: boolean): void {
  response.cookies.set({
    name: CLIENT_HAD_SESSION_COOKIE,
    value: '',
    path: '/',
    maxAge: 0,
    sameSite: 'lax',
    secure,
    httpOnly: false,
  })
}
